/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
// import Conteudo from "./Conteudo";
import Unidade from "./Unidade";

const Professional = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/:id`} component={Unidade} />
      {/* <Route path={`${match.url}/conteudo/:id`} component={Conteudo} />
      <Route path={`${match.url}/:id`} component={Unidade} /> */}
    </Switch>
  </div>
);

export default Professional;
